import React, { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useViewport } from '@chilecompra/react-kit'
import { Typography } from '@chilecompra/react-kit/components'
import routes from '../../config/settings/routes'
import Jumbotron from '../../components/Basics/Jumbotron'
import {
  Card,
  CustomTypography,
  DialogLink,
  ExclamationIcon,
  GridContainer,
  GridItem,
  Image,
  Info,
  InfoCircle,
  Root
} from './Home.styles'
import theme from '../../config/styles/theme'

/**
 * The Home's container.
 */
const Home = () => {
  const { size } = useViewport()
  const navigate = useNavigate()
  const handleGoTo = useCallback(route => () => navigate(route), [])

  return (
    <Root>
      <GridContainer>
        <GridItem xs={12}>
          <Jumbotron color="blue" height={size.isUpToMedium ? '454px' : 'auto'}>
            <GridContainer spacing={1}>
              <GridItem md={8} xs={12}>
                <CustomTypography
                  color="white"
                  display={size.isUpToMedium ? 'block' : 'inline'}
                  fontSize="47px"
                  lineHeight="54px"
                  margin={size.isUpToMedium ? '96px 0 0' : '96px 8px 0 0'}
                  variant="h1"
                  width={size.isUpToMedium ? '608px' : 'auto'}
                >
                  Datos Abiertos de las <strong>compras públicas</strong> de <strong>Chile</strong>
                </CustomTypography>
                {size.isUpToMedium && (
                  <GridItem xs={9}>
                    <CustomTypography
                      color="white"
                      fontSize="18px"
                      lineHeight="24px"
                      margin="8px"
                      variant="body1"
                      width="474px"
                    >
                      Explora toda la información de compras realizadas por los organismos públicos a través de Mercado
                      Público.
                    </CustomTypography>
                    <Card color="primary" padding="16px 4px" height="78px">
                      <GridContainer>
                        <GridItem xs={1}>
                          <Info>
                            <InfoCircle>
                              <ExclamationIcon />
                            </InfoCircle>
                          </Info>
                        </GridItem>
                        <GridItem xs={11} justifyContent="flex-start">
                          <GridItem xs={12}>
                            <Typography fontSize="14px" fontWeight="bold" lineHeight="16px" variant="h1">
                              Prueba las nuevas secciones del sitio de Datos Abiertos de ChileCompra
                            </Typography>
                          </GridItem>
                          <GridItem xs={12}>
                            <Typography
                              fontSize="14px"
                              lineHeight="16px"
                              variant="body1"
                              color={theme.palette.custom.textGray}
                            >
                              Revisa la información disponible en las nuevas páginas exclusivas para <br />
                              <DialogLink to={routes.agilePurchase}>Compra Ágil </DialogLink> y{' '}
                              <DialogLink to={routes.smallerCompanies}>Empresas de Menor Tamaño </DialogLink>.
                            </Typography>
                          </GridItem>
                        </GridItem>
                      </GridContainer>
                    </Card>
                  </GridItem>
                )}
              </GridItem>
              <GridItem md={4} xs={12}>
                <Card color="blank" margin="24px 0 16px" onClick={handleGoTo(routes.organizations)}>
                  <GridContainer spacing={2}>
                    <GridItem xs={2}>
                      <Image src="/assets/images/01-transacciones.svg" />
                    </GridItem>
                    <GridItem xs={10}>
                      <Typography fontSize="16px" fontWeight="bold" lineHeight="18.75px" variant="h1">
                        Transacciones de todos los organismos públicos
                      </Typography>
                      <Typography fontSize="13px" lineHeight="15.23px" variant="body1">
                        Revisa en detalle toda la información de compras de cada organismo.
                      </Typography>
                    </GridItem>
                  </GridContainer>
                </Card>
                <Card color="blank" margin="0 0 16px" onClick={handleGoTo(routes.comparator)}>
                  <GridContainer spacing={2}>
                    <GridItem xs={2}>
                      <Image src="/assets/images/02-herramientas.svg" />
                    </GridItem>
                    <GridItem xs={10}>
                      <Typography fontSize="16px" fontWeight="bold" lineHeight="18.75px" variant="h1">
                        Comparador de organismos compradores
                      </Typography>
                      <Typography fontSize="13px" lineHeight="15.23px" variant="body1">
                        Conoce la diferencia de las compras realizadas entre distintos organismos.
                      </Typography>
                    </GridItem>
                  </GridContainer>
                </Card>
                <Card
                  color="blank"
                  margin={size.isUpToMedium ? '0' : '0 0 48px'}
                  onClick={handleGoTo(routes.downloads)}
                >
                  <GridContainer spacing={2}>
                    <GridItem xs={2}>
                      <Image src="/assets/images/03-comparador.svg" />
                    </GridItem>
                    <GridItem xs={10}>
                      <Typography fontSize="16px" fontWeight="bold" lineHeight="18.75px" variant="h1">
                        Herramientas de descarga masiva de datos
                      </Typography>
                      <Typography fontSize="13px" lineHeight="15.23px" variant="body1">
                        Descarga órdenes de compra, licitaciones y otros procesos en formato csv.
                      </Typography>
                    </GridItem>
                  </GridContainer>
                </Card>
              </GridItem>
            </GridContainer>
          </Jumbotron>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default Home
